export const enum SCAFFOLDTYPES {
  FRAME = "frame",
}
